import React from 'react';
import { translate } from '../../../Services/translation';
import { setActiveTab } from '../../../Actions/QuickSearch.action';
import { useDispatch } from 'react-redux';
import clsx from 'clsx';

const QuickSearchResultTabItem = ({ resultKey, quantity, active }) => {
  const dispatch = useDispatch();
  var translation = translate(`quicksearchheader.${resultKey}`);
  return (
    <li
      className={clsx(
        'py-2',
        active ? 'text-gray-900' : 'text-gray-500',
        active && 'border-b',
        'border-solid',
        'border-gray-900',
        'cursor-pointer',
        'text-md'
      )}
      onClick={() => dispatch(setActiveTab(resultKey))}
    >
      <span className="font-bold">{translation}</span>
      <span> {'(' + quantity + ')'}</span>
    </li>
  );
};

export default QuickSearchResultTabItem;
